/**<params config data>说明
 * position 控制文本框宽度位置
 *
 * 如果组件要显示video的话，要在对应的page页面添加scroll监听来控制播放，不在组件里添加的原因是有可能会复数引用
 */
import { useRef } from 'react';
import css from './index.module.scss';
import { TextBanner } from '@/componentsH5/ProductDetailComponents';
import EFReplayH5 from '@/components/UI/svg/Icons/EFReplayH5';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import Image from '@/components/UI/Image';

const item = {
    title: '576Wh Capacity',
    synopsis: 'Double up or go lightweight.',
    desc: 'RIVER Max has two 288Wh batteries. Detach the bottom one when weight takes priority or leave it on to power twice as much.',
    img_url: '/img/rivermax/rivermax1_h5.jpg',
    video_src: [],
    alt: '',
};
const configs = {
    position: 'top',
    margin: 'auto',
    padding: '0',
    isShowVideo: false,
    fullScreen: true,
    text: 'center',
};
export default function TextWithImage(props: any) {
    const { config, data = item } = props;
    const videoRef = useRef(null);
    const configTypes = { ...configs, ...config };
    const { EFPic } = createEFPic(config?.webpUrl);

    if (!configTypes.imgHeight) {
        configTypes.imgHeight = configTypes.fullScreen ? '3.2rem' : '3.6rem';
    }

    if (!configTypes.imgWidth) {
        configTypes.imgWidth = configTypes.fullScreen ? '100%' : '3.55rem';
    }

    return (
        <div
            className={`${css.TextWithImage} ${config.text ? config.text : 'center'}Context`}
            style={{ margin: configTypes.margin, padding: configTypes.padding }}
        >
            <div
                className="text-banner-out1"
                key={data.title}
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: configTypes.position === 'top' ? 'column' : 'column-reverse',
                }}
            >
                <div
                    className="text-banner-out2"
                    style={{
                        marginBottom: configTypes.position === 'top' ? '30px' : '0',
                        marginTop: configTypes.position === 'bottom' ? '30px' : '0',
                    }}
                >
                    <TextBanner config={configTypes} data={data} />
                    <div className="font-family-medium tip" style={{ marginTop: configTypes.tip_margintop }}>
                        <p>{data.tip}</p>
                    </div>
                </div>

                <div
                    className="text-banner-image signFullImgsBox"
                    style={{
                        position: 'relative',
                        height: configTypes.imgHeight,
                        width: configTypes.imgWidth,
                    }}
                >
                    {data.img_url &&
                        (Array.isArray(data.img_url) ? (
                            <EFPic name={data.img_url} className={configTypes.fullScreen ? '' : 'borderImgs'} alt={data.title ? data.title : data.synopsis} />
                        ) : (
                            <Image
                                src={data.img_url}
                                layout="fill"
                                className={configTypes.fullScreen ? '' : 'borderImgs'}
                                alt={data.title ? data.title : data.synopsis}
                            />
                        ))}
                    {configTypes.isShowVideo && (
                        <div className="video-replay" onClick={() => videoRef.current?.play()}>
                            <EFReplayH5 style={{ fontSize: '.34rem' }} />
                        </div>
                    )}
                    {configTypes.isShowVideo && <EFVideo ref={videoRef} sources={data.video_src} className="video" loop={false} />}
                    {props.children}
                </div>

                {data.tipBottom && (
                    <div className="font-family-medium tipBottom">
                        <p>{data.tipBottom}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
